/*
if (!customElements.get('three-button-products')) {
  customElements.define(
    'three-button-products',
    class ThreeButtonProducts extends HTMLElement {
      connectedCallback() {
        this.productsContainer = this.querySelector('[data-three-buttons-products]');
        this.results = this.querySelector('[data-three-buttons-results]');
        this.status = this.querySelector('[data-three-buttons-status]');
        this.placeholder = this.querySelector('[data-three-buttons-placeholder]');
        this.abortController = null;

        this.addEventListener('click', (event) => {
          const tab = event.target.closest('.three-buttons__button');
          if (tab && this.contains(tab)) {
            const selectedGroup = tab.closest('.three-buttons__group');
            this.querySelectorAll('.three-buttons__group[open]').forEach((group) => {
              if (group !== selectedGroup) group.removeAttribute('open');
            });
          }

          const option = event.target.closest('[data-product-tag]');
          if (option && this.contains(option)) {
            event.preventDefault();
            this.querySelectorAll('[data-product-tag].is-active').forEach((button) => {
              button.classList.remove('is-active');
              button.removeAttribute('aria-current');
            });
            option.classList.add('is-active');
            option.setAttribute('aria-current', 'true');
            this.loadProducts(option.href, option.dataset.productLabel);
            return;
          }

          const paginationLink = event.target.closest('[data-three-buttons-results] a[href]');
          if (paginationLink && this.contains(paginationLink)) {
            event.preventDefault();
            this.loadProducts(paginationLink.href, this.status.textContent, false);
          }
        });
      }

      async loadProducts(url, label, scrollToResults = true) {
        if (this.abortController) this.abortController.abort();
        this.abortController = new AbortController();

        this.productsContainer.classList.remove('is-empty');
        this.productsContainer.setAttribute('aria-busy', 'true');
        this.placeholder.hidden = true;
        this.status.hidden = false;
        this.status.textContent = `Loading ${label} products…`;
        this.results.innerHTML = '';

        try {
          const response = await fetch(url, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' },
            signal: this.abortController.signal,
          });

          if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

          const page = new DOMParser().parseFromString(await response.text(), 'text/html');
          const collectionResults = page.querySelector('.main-products-grid__results');
          if (!collectionResults) throw new Error('Product grid was not found');

          const productGrid = collectionResults.querySelector('ul[role="list"]');
          if (productGrid) {
            const productItems = Array.from(productGrid.querySelectorAll(':scope > li.js-pagination-result')).filter(
              (item) => item.querySelector('.card--product')
            );
            const visibleProducts = new Set(productItems.slice(0, 5));

            Array.from(productGrid.children).forEach((item) => {
              if (!visibleProducts.has(item)) item.remove();
            });
          }

          collectionResults.querySelectorAll('.js-pagination').forEach((pagination) => {
            const paginationContainer = pagination.closest('nav');
            if (paginationContainer) paginationContainer.remove();
          });

          this.status.textContent = label;
          this.results.innerHTML = collectionResults.innerHTML;

          if (typeof initLazyImages === 'function') {
            initLazyImages();
          }

          this.productsContainer.removeAttribute('aria-busy');

          if (scrollToResults) {
            this.productsContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        } catch (error) {
          if (error.name === 'AbortError') return;
          window.location.assign(url);
        }
      }
    }
  );
}
*/

if (!customElements.get('three-button-products')) {
  customElements.define(
    'three-button-products',
    class ThreeButtonProducts extends HTMLElement {
      connectedCallback() {
        this.productsContainer = this.querySelector(
          '[data-three-buttons-products]'
        );
        this.results = this.querySelector(
          '[data-three-buttons-results]'
        );
        this.status = this.querySelector(
          '[data-three-buttons-status]'
        );
        this.placeholder = this.querySelector(
          '[data-three-buttons-placeholder]'
        );
        this.abortController = null;

        // Prevent duplicate event listeners if Shopify reconnects the section.
        if (this.initialized) return;
        this.initialized = true;

        this.addEventListener('click', (event) => {
          const tab = event.target.closest('.three-buttons__button');

          if (tab && this.contains(tab)) {
            const selectedGroup = tab.closest(
              '.three-buttons__group'
            );

            this.querySelectorAll(
              '.three-buttons__group[open]'
            ).forEach((group) => {
              if (group !== selectedGroup) {
                group.removeAttribute('open');
              }
            });

            // Automatically select the first option in this category.
            const firstOption = selectedGroup?.querySelector(
              '[data-product-tag]'
            );

            if (firstOption) {
              event.preventDefault();
              selectedGroup.setAttribute('open', '');
              this.selectOption(firstOption);
            }

            return;
          }

          const option = event.target.closest('[data-product-tag]');

          if (option && this.contains(option)) {
            event.preventDefault();
            this.selectOption(option);
            return;
          }

          const paginationLink = event.target.closest(
            '[data-three-buttons-results] a[href]'
          );

          if (paginationLink && this.contains(paginationLink)) {
            event.preventDefault();

            this.loadProducts(
              paginationLink.href,
              this.currentOptionLabel,
              false
            );
          }
        });

        // Automatically load the first option when the page loads.
        const defaultGroup =
          this.querySelector('.three-buttons__group[open]') ||
          this.querySelector(
            '.three-buttons__group:has([data-product-tag^="match_meat:"])'
          ) ||
          this.querySelector('.three-buttons__group');

        const firstOption = defaultGroup?.querySelector(
          '[data-product-tag]'
        );

        if (firstOption) {
          this.selectOption(firstOption, false);
        }
      }

      selectOption(option, scrollToResults = true) {
        this.querySelectorAll(
          '[data-product-tag].is-active'
        ).forEach((button) => {
          button.classList.remove('is-active');
          button.removeAttribute('aria-current');
        });

        option.classList.add('is-active');
        option.setAttribute('aria-current', 'true');

        const label = option.dataset.productLabel;
        const tag = option.dataset.productTag || '';

        this.currentOptionLabel = label;

        // Change the heading only, not the category or option button labels.
        if (
          tag.startsWith('match_cheese:') ||
          tag.startsWith('match_meat:')
        ) {
          this.currentHeader = `Perfect pours for ${label}`;
        } else if (tag.startsWith('match_wine:')) {
          this.currentHeader = `What to serve with ${label}`;
        } else {
          this.currentHeader = label;
        }

        this.loadProducts(
          option.href,
          label,
          scrollToResults
        );
      }

      async loadProducts(
        url,
        label,
        scrollToResults = true
      ) {
        if (this.abortController) {
          this.abortController.abort();
        }

        this.abortController = new AbortController();

        this.productsContainer.classList.remove('is-empty');
        this.productsContainer.setAttribute('aria-busy', 'true');
        this.placeholder.hidden = true;
        this.status.hidden = false;
        this.status.textContent = `Loading ${label} products…`;
        this.results.innerHTML = '';

        try {
          const response = await fetch(url, {
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
            },
            signal: this.abortController.signal,
          });

          if (!response.ok) {
            throw new Error(
              `Request failed with status ${response.status}`
            );
          }

          const page = new DOMParser().parseFromString(
            await response.text(),
            'text/html'
          );

          const collectionResults = page.querySelector(
            '.main-products-grid__results'
          );

          if (!collectionResults) {
            throw new Error('Product grid was not found');
          }

          const productGrid = collectionResults.querySelector(
            'ul[role="list"]'
          );

          if (productGrid) {
            const productItems = Array.from(
              productGrid.querySelectorAll(
                ':scope > li.js-pagination-result'
              )
            ).filter((item) =>
              item.querySelector('.card--product')
            );

            const visibleProducts = new Set(
              productItems.slice(0, 5)
            );

            Array.from(productGrid.children).forEach((item) => {
              if (!visibleProducts.has(item)) {
                item.remove();
              }
            });
          }

          collectionResults
            .querySelectorAll('.js-pagination')
            .forEach((pagination) => {
              const paginationContainer = pagination.closest('nav');

              if (paginationContainer) {
                paginationContainer.remove();
              }
            });

          this.results.innerHTML = collectionResults.innerHTML;

          // Display the custom heading after the products load.
          this.status.textContent =
            this.currentHeader || label;

          if (typeof initLazyImages === 'function') {
            initLazyImages();
          }

          this.productsContainer.removeAttribute('aria-busy');

          if (scrollToResults) {
            this.productsContainer.scrollIntoView({
              behavior: 'smooth',
              block: 'start',
            });
          }
        } catch (error) {
          if (error.name === 'AbortError') return;

          this.productsContainer.removeAttribute('aria-busy');
          window.location.assign(url);
        }
      }
    }
  );
}
